import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { TraceableComponentsApiService } from '../../../api/traceable-components/traceableComponentsApiService';
import { TraceableComponentNode } from '../../../api/traceable-components/traceableComponentNode';
import { TreeNodeViewModel } from './tree-node-view-model';

@Component({
    selector: 'traceable-components-tree',
    templateUrl: './traceable-components-tree.component.html',
    styleUrls: ['./traceable-components-tree.component.css'],
    standalone: false
})
export class TraceableComponentsTreeComponent implements OnInit {
  @Input() assetId: string | undefined = undefined;
  @Input() source: string | undefined = undefined;
  displayedColumns: string[] = ['code', 'description', 'serial-number', 'controls'];
  loading: number = 0;
  loadedNodes: TraceableComponentNode[] = [];

  private transformer = (node: TraceableComponentNode, level: number) => {
    return {
      id: node.Id,
      code: node.Code,
      description: node.Description,
      serialNumber: node.SerialNumber,
      expandable: node.HasChildren,
      level: level,
    } as TreeNodeViewModel;
  }

  treeControl = new FlatTreeControl<TreeNodeViewModel>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => node.Children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(private traceableComponentsApiService: TraceableComponentsApiService) { }

  ngOnInit(): void {
    if (!this.assetId || !this.source)
      return;

    this.loading++;
    this.traceableComponentsApiService
      .getAssetTraceableComponents(this.assetId!, this.source!)
      .subscribe(nodes => this.handleLoadedNodesRoot(nodes));
  }

  handleLoadedNodesRoot(nodes: TraceableComponentNode[]) {
    this.loadedNodes = nodes;

    nodes.forEach(node => {
      if (node.HasChildren) {
        this.loading++;
        this.traceableComponentsApiService
          .getTraceableComponentChildren(node.Id, this.source!)
          .subscribe(children => this.handleLoadedNodes(node, children));
      }
    });

    this.loading--;
    this.setupTree();
  }

  handleLoadedNodes(parentNode: TraceableComponentNode, nodes: TraceableComponentNode[]) {
    parentNode.Children = nodes;

    nodes.forEach(node => {
      if (node.HasChildren) {
        this.loading++;
        this.traceableComponentsApiService
          .getTraceableComponentChildren(node.Id, this.source!)
          .subscribe(children => {
            this.handleLoadedNodes(node, children);
          });
      }
    });

    this.loading--;
    this.setupTree();
  }

  private setupTree() {
    if (this.loading == 0) {
      this.dataSource.data = this.loadedNodes;
      this.treeControl.dataNodes.forEach(x => {
        if (x.level < 2)
          this.treeControl.expand(x);
      });
    }
  }
}
